import * as server from "@/utils/http"

export const _phccloud = params=> server.get("/physical-report/phccloud",params)
export const _primaryEnrolment = params=> server.get("/physical-report/primaryEnrolment",params)
export const _middlePrimarySecondary = params=> server.get("/physical-report/middlePrimarySecondary",params)
export const _university = params=> server.get("/physical-report/university",params)
export const _generalInspection = params=> server.get("/physical-report/generalInspection",params)
export const _monthChildren = params=> server.get("/physical-report/monthChildren",params)
export const _ageChildren = params=> server.get("/physical-report/ageChildren",params)
export const _hearing = params=> server.get("/physical-report/hearing",params)
export const _vision = params=> server.get("/physical-report/vision",params)
export const _dentalCaries = params=> server.get("/physical-report/dentalCaries",params)
export const _middleEar = params=> server.get("/physical-report/middleEar",params)
export const _refractive = params=> server.get("/physical-report/refractive",params)
export const _bmdReport = params=> server.get("/physical-report/bmdReport",params)
export const _drReport = params=> server.get("/physical-report/drReport",params)
export const _lisReport = params=> server.get("/physical-report/lisReport",params)
export const _tianHeChildrenEnrolment = params=> server.get("/physical-report/tianHeChildrenEnrolment",params)
export const _congHuaKindergarten = params=> server.get("/physical-report/congHuaKindergarten",params)
export const _huangPuUniversity = params=> server.get("/physical-report/huangPuUniversity",params)
